// Single source of truth for the public contact address. It was previously
// written out by hand in several components, which is how the site ended up
// advertising info@/support@onhuman.com on the contact page while the footer
// used this one.
export const CONTACT_EMAIL = "contact@onhumanresources.com";

export const LINKEDIN_URL = "";
